export default __webpack_public_path__ + "static/media/logo-ae-sharafdg.1ed668d7.svg";